import { ProductDetailSlotsDTO } from '../ProductDetailSlotsDTO';

export const ProductSlotMock: ProductDetailSlotsDTO = {
    slots: [
        {
            type: 'payment_reinsurance',
            details: {
                items: [
                    {
                        name: 'PayPal',
                        image: {
                            icon: 'https://dev01-eu04-sephora.demandware.net/on/demandware.static/-/Sites/default/dw140095c5/checkout/paypal-rounded.svg',
                        },
                        link: '<a href="https://faq.sephora.fr/s/article/QUELS-SONT-LES-MODES-DE-PAIEMENT-ACCEPTÉS-SUR-SEPHORA-FR-ET-EN-MAGASIN#:~:text=Sur sephora.fr%2C nous acceptons,espèces et les chèques cadeaux." class="reinssurance-payment-method-text1"><u>Paiement <strong>3x</strong> ou <strong>4x</strong></u></a>',
                    },
                ],
            },
        },
        {
            type: 'deliveryandreturnsinfoscontent',
            details: {
                items: [
                    {
                        name: 'Delivery popup',
                        description:
                            '<p class="reinssurance-delivery-and-returns-infos-text1">Livraison gratuite à partir de 60€ d\'achats</p>',
                    },
                ],
            },
        },
    ],
};

export const ProductSlotsMock: ProductDetailSlotsDTO = {
    slots: [
        {
            type: 'payment_reinsurance',
            details: {
                items: [
                    {
                        name: 'PayPal',
                        image: {
                            icon: 'https://dev01-eu04-sephora.demandware.net/on/demandware.static/-/Sites/default/dw140095c5/checkout/paypal-rounded.svg',
                        },
                        link: '<a href="https://faq.sephora.fr/s/article/QUELS-SONT-LES-MODES-DE-PAIEMENT-ACCEPTÉS-SUR-SEPHORA-FR-ET-EN-MAGASIN#:~:text=Sur sephora.fr%2C nous acceptons,espèces et les chèques cadeaux." class="reinssurance-payment-method-text1"><u>Paiement <strong>3x</strong> ou <strong>4x</strong></u></a>',
                    },
                    {
                        name: 'Klarna',
                        link: '\n    <a href="https://uat.sephora.fr/aide-sephora/" class="reinssurance-payment-method-text1"><u>Payer en 3x ou 4x</u></a>\n',
                        image: {
                            icon: 'https://uat.sephora.fr/on/demandware.static/-/Sites/default/dw98115905/checkout/klarna-rounded.svg',
                        },
                    },
                ],
            },
        },
    ],
};
